// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toolbar-anon-button{height:1rem;-ms-flex:none;flex:none;margin-top:auto;margin-bottom:auto;-ms-flex-item-align:start;align-self:flex-start}", ""]);
// Exports
module.exports = exports;
